/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @next/next/no-img-element */
import {Row, Statistic} from 'antd';
import {IReactionDisposer, autorun} from 'mobx';
import useCommon from '@utils/hooks/common';
import YellowDollarIcon from '@public/icon/yellow-dollar-2.svg';
import BlueDiamond from '@public/icon/blue-diamond-2.svg';
import {useRouter} from 'next/router';
import React, {useState, useEffect, useRef} from 'react';
import styles from './styles';
import {compactFormatter, compactFormatterFourDigit} from '@utils/index';
import classNames from 'classnames';
import {isMerchantGateway} from '@utils/gateway/merchant-gateway';

const AssetsRow = ({
  isAssetsVisible,
  isPlayerCountVisible,
}: {
  isAssetsVisible: boolean;
  isPlayerCountVisible: boolean;
}) => {
  const {classes, t, user, lobbySocket, system} = useCommon({
    withTranslation: null,
    withStyles: styles,
    observers: ['user', 'lobbySocket', 'system'],
  });

  const [coinBalance, setCoinBalance] = useState<number>(user?.getCoinWalletBalance());
  const [diamondBalance, setDiamondBalance] = useState<number>(user?.getDiamondWalletBalance());
  const [playerCount, setPlayerCount] = useState<number>(lobbySocket?.onlinePlayerCount || 0);

  const autorunDisposer = useRef<IReactionDisposer>();

  useEffect(() => {
    autorunDisposer.current = autorun(() => {
      if (lobbySocket?.onlinePlayerCount && lobbySocket?.onlinePlayerCount != playerCount) {
        setPlayerCount(lobbySocket.onlinePlayerCount);
      }
    });
    return () => {
      autorunDisposer.current();
    };
  }, []);

  // useEffect(() => {
  //   const diamondWalletBalance = user?.getDiamondWalletBalance();
  //   setDiamondBalance(diamondWalletBalance);
  // }, [user.playerInfo]);

  // useEffect(() => {
  //   autorun(() => {
  //     const setBalances = async () => {
  //       if (user) {
  //         await user?.refreshPlayerInfo();

  //         // Set timeout otherwise money may be be updated
  //         await new Promise(resolve => {
  //           setTimeout(() => {
  //             resolve(null);
  //           }, 10);
  //         });
  //         // TODO @@ should update after deposit/withdraw
  //         setCoinBalance(await user?.getCoinWalletBalance());
  //         setDiamondBalance(await user?.getDiamondWalletBalance());
  //       }
  //     };

  //     setBalances();
  //   });
  // }, [user]);

  useEffect(() => {
    autorun(() => {
      if (!user?.playerInfo) return;

      if (user?.getCoinWalletBalance() != coinBalance) {
        setCoinBalance(user?.getCoinWalletBalance());
      }
      if (user?.getDiamondWalletBalance() != diamondBalance) {
        setDiamondBalance(user?.getDiamondWalletBalance());
      }
    });
  }, [user]);

  const hasDepositFunction = !user?.isThirdPartyGateway() || isMerchantGateway();

  return (
    <section className={classes.assetsRowContainer}>
      <div className={classes.borderContainer}>
        <div
          className={classNames(classes.row, {
            emptySpace: !isAssetsVisible && !isPlayerCountVisible,
          })}
        >
          <Row
            onClick={() => {
              if (!user?.isThirdPartyGateway() || isMerchantGateway()) {
                system?.showModalSheet('depositWithdraw');
              }
            }}
            className={classNames(classes.numberContainerLeft, {
              [classes.hidden]: !isAssetsVisible,
              unclickable: !hasDepositFunction,
            })}
          >
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <img src="/icon/layout/coin.svg" alt="coin" width="20" style={{marginRight: 10}} />
              <Statistic
                className={classes.usdStatistic}
                prefix={isMerchantGateway() ? 'USD\u00A0' : 'USD$'}
                valueStyle={{color: 'white', fontSize: '12px', fontWeight: 500}}
                value={coinBalance}
                formatter={compactFormatterFourDigit}
              />
            </div>
            {hasDepositFunction && (
              <img src="/icon/layout/add.svg" alt="add" className={classes.addIcon} />
            )}
          </Row>

          <Row
            onClick={() => {
              system?.showModalSheet('purchase');
            }}
            className={classNames(classes.numberContainerRight, {
              [classes.hidden]: !isAssetsVisible,
            })}
          >
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <img src="/icon/layout/diamond.svg" alt="diamond" style={{marginRight: 5}} />
              <Statistic
                valueStyle={{color: 'white', fontSize: '12px', fontWeight: 500}}
                // value={user.getCurrencyValue(CURRENCIES.DIAMOND)}
                value={diamondBalance}
                formatter={compactFormatter}
              />
            </div>

            <img src="/icon/layout/add.svg" alt="add" className={classes.addIcon} />
          </Row>

          <div
            className={classNames(classes.onlinePlayerCountContainer, {
              [classes.hidden]: !isPlayerCountVisible,
            })}
          >
            <img src="/icon/layout/online-player-count.svg" alt="player" width="20" />
            <div>{playerCount}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssetsRow;
